import { SearchAnalysesResults } from '@modules/feed/components/SearchAnalysesResults';
import { SearchAnalysisToolbar } from '@modules/feed/components/SearchAnalysisToolbar';
import { SearchQueryBuilderV2 } from '@modules/feed/components/SearchQueryBuilder/SearchQueryBuilderV2';
import { useIsFeedbackListRedesignEnabled } from '@modules/feedbackV2/common/hooks';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { Stack } from '@mui/material';

export function FeedAnalysis() {
  const isFeedbackListRedesignEnabled = useIsFeedbackListRedesignEnabled();

  return (
    <Stack
      spacing={3}
      sx={{
        py: 2,
        px: 3,
        width: '100%',
      }}
      alignItems="center"
    >
      <Stack sx={{ width: '100%' }}>
        <SearchAnalysisToolbar />
      </Stack>
      <QueryBuilderStoreProvider>
        <Stack
          spacing={3}
          sx={{
            maxWidth: isFeedbackListRedesignEnabled ? 1300 : undefined,
            width: '100%',
          }}
        >
          <SearchQueryBuilderV2 />
          <SearchAnalysesResults />
        </Stack>
      </QueryBuilderStoreProvider>
    </Stack>
  );
}
